import React from 'react'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  swatch: {
    width: 12,
    height: 12,
    borderRadius: '50%',
    display: 'inline-block',
    marginRight: theme.spacing(1),
    boxSizing: 'border-box',
  },
  recurring: { backgroundColor: '#2196F3' },
  override: { backgroundColor: '#FFB300' },
  blocked: { backgroundColor: '#EF5350' },
  synced: {
    backgroundImage:
      'repeating-linear-gradient(135deg, #FFEBEE 0 3px, #FFFFFF 3px 6px)',
    border: '1px dashed #EF5350',
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(3),
    [theme.breakpoints.only('xs')]: {
      marginRight: theme.spacing(1.5),
    },
  },
}))

const Legend = () => {
  const classes = useStyles()
  return (
    <Box display="flex" alignItems="center" px={2} py={1.5} flexWrap="wrap">
      <Box className={classes.item}>
        <span className={`${classes.swatch} ${classes.recurring}`} />
        <Typography variant="body2" color="textSecondary">
          Recurring
        </Typography>
      </Box>
      <Box className={classes.item}>
        <span className={`${classes.swatch} ${classes.override}`} />
        <Typography variant="body2" color="textSecondary">
          One-Time Availability
        </Typography>
      </Box>
      <Box className={classes.item}>
        <span className={`${classes.swatch} ${classes.blocked}`} />
        <Typography variant="body2" color="textSecondary">
          Blocked
        </Typography>
      </Box>
      <Box className={classes.item}>
        <span className={`${classes.swatch} ${classes.synced}`} />
        <Typography variant="body2" color="textSecondary">
          Synced from Google Calendar
        </Typography>
      </Box>
    </Box>
  )
}

export default Legend
